import React from "react";
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import type { IntlShape } from "react-intl";
import type { Money } from "../stores/BaseTypes";
export type MoneyAmountProps = {
	amount: Money | null | undefined;
	intl: IntlShape;
	showNoCurrencyIfZero?: boolean;
	unitAddition?: string;
};

function MoneyAmount({ amount, showNoCurrencyIfZero, unitAddition, intl }: MoneyAmountProps) {
	if (showNoCurrencyIfZero && amount && amount.amount === 0) {
		return <span>0</span>;
	}

	const notAvailablePriceExplanation = intl.formatMessage({ id: "NOT_AVAILABLE_PRICE_EXPLANATION" });

	if (!amount) {
		return (
			<span className="no-amount" title={notAvailablePriceExplanation}>
				<FormattedMessage id="NOT_AVAILABLE_ABBREVIATION" />
			</span>
		);
	}

	// show 2 fraction digits for all currencies except for JPY
	const fractionDigits = amount.currency === "JPY" ? 0 : 2;

	if (unitAddition) {
		return (
			<FormattedMessage
				id="ORC_PRICE_WITH_UNIT"
				values={{
					price: intl.formatNumber(amount.amount, {
						maximumFractionDigits: fractionDigits,
						minimumFractionDigits: fractionDigits,
						format: "currency",
						currency: amount.currency,
					}),
					unitAddition,
				}}
			/>
		);
	}

	return (
		<FormattedNumber
			minimumFractionDigits={fractionDigits}
			maximumFractionDigits={fractionDigits}
			value={amount.amount}
			format="currency"
			currency={amount.currency}
		/>
	);
}

export default injectIntl(MoneyAmount);
